import React from 'react';
import { endPoints } from 'shared/config/endPoints';
import { IRoute } from '../types';

export const homeRoutes: IRoute[] = [
  {
    index: true,
    path: endPoints.DEFAULT_PAGE,
    element: null,
  },
];
